module.exports = __webpack_public_path__ + "img/img-form-menu.d6b6d8af.webp";